import { StyledCtaButton, StyledCtaText } from './styles';

const CtaButton = ({
  text,
  onClick,
  sx,
  textSx,
  notFullWidth,
  disabled,
  startIcon,
  endIcon,
  ...rest
}) => {
  return (
    <StyledCtaButton
      variant="contained"
      disabled={disabled}
      onClick={onClick}
      sx={sx}
      startIcon={startIcon}
      endIcon={endIcon}
      {...rest}
    >
      <StyledCtaText disabled={disabled} sx={textSx}>
        {text}
      </StyledCtaText>
    </StyledCtaButton>
  );
};

export default CtaButton;
